import { render, staticRenderFns } from "./AsideView.vue?vue&type=template&id=19e199ad&scoped=true"
import script from "./AsideView.vue?vue&type=script&lang=js"
export * from "./AsideView.vue?vue&type=script&lang=js"
import style0 from "./AsideView.vue?vue&type=style&index=0&id=19e199ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e199ad",
  null
  
)

export default component.exports